import {MathUtils} from '../../../../../shared/utils/MathUtils.ts'
import {UIGameTimedAnimation} from './UIGameTimedAnimation.ts'
import {type PIXI} from '@colonist/pixi'

export interface FadeAnimationOptions {
    initialAlpha: number
    fadeSpeed: number
    completionPercentageToStartFade: number
    isFadeIn: boolean
}

export class UIGameFadeAnimation extends UIGameTimedAnimation {
    private readonly options: FadeAnimationOptions
    protected readonly forceEnableAnimation: boolean = false
    private completionPercentage: number = 0

    constructor(viewToAnimate: PIXI.Container, animationDuration: number = 500, options?: FadeAnimationOptions) {
        super(animationDuration)
        this.viewToAnimate = viewToAnimate
        this.options = options ?? UIGameFadeAnimation.getDefaultOptions()
    }

    start() {
        this.viewToAnimate.alpha = this.options.initialAlpha
        super.start()
        return this
    }

    updateAnimation(deltaTime: number, elapsedMS: number, completionPercentage?: number): void {
        this.completionPercentage = completionPercentage != undefined ? completionPercentage : this.totalElapsedMS / this.duration
        this.viewToAnimate.alpha = this.calculateAlpha(deltaTime)
    }

    private calculateAlpha(deltaTime: number): number {
        if(this.completionPercentage < this.options.completionPercentageToStartFade) return this.viewToAnimate.alpha

        const fadeAdjustment = this.options.fadeSpeed * deltaTime * (this.options.isFadeIn ? 1 : -1)
        const newAlpha = this.viewToAnimate.alpha + fadeAdjustment

        return MathUtils.clampBetweenZeroAndOne(newAlpha)
    }

    resetToDefaultState(): void {
        this.viewToAnimate.alpha = this.options.isFadeIn ? 1 : 0
    }

    private static getDefaultOptions(): FadeAnimationOptions {
        return {
            initialAlpha: 0,
            fadeSpeed: 0.1,
            completionPercentageToStartFade: 0.5,
            isFadeIn: true,
        }
    }
}
